import React, { useState } from 'react';
import { LUCCHETTO_HEX, raggruppaConsistenze } from './ssmateConsistenze';

// Dialog condiviso (desktop + PWA agente) per il risultato Lucchetto SSMATE.
// Finestra ad altezza fissa (non si deforma col contenuto): header/sotto-testata fissi,
// corpo con scroll interno. Categorie evidenziate stile Copertura.
// Theme-aware: prop `dark` (default false = chiaro). Il desktop resta chiaro; la PWA agente
// passa dark={!light} per adattarsi al tema (evita testo chiaro su sfondo chiaro).
function palette(dark) {
  return dark ? {
    cardBg: '#0e1626', ink: '#eef2ff', muted: '#8b98c9', faint: '#5b6690',
    headBorder: 'rgba(255,255,255,.10)', subBg: 'rgba(255,255,255,.03)', subBorder: 'rgba(255,255,255,.08)',
    rowBorder: 'rgba(255,255,255,.06)', chipColor: '#fbbf24', chipBg: 'rgba(251,191,36,.15)',
    shotBorder: 'rgba(255,255,255,.14)', shotBg: 'rgba(255,255,255,.05)', shotColor: '#cdd6f0',
    okColor: '#4ade80', noColor: '#f87171',
  } : {
    cardBg: '#fff', ink: '#0f172a', muted: '#64748b', faint: '#94a3b8',
    headBorder: '#eef2f7', subBg: '#fafbfc', subBorder: '#f1f5f9',
    rowBorder: '#f4f6fa', chipColor: '#b45309', chipBg: '#fef3c7',
    shotBorder: '#e2e8f0', shotBg: '#fff', shotColor: '#475569',
    okColor: '#15803d', noColor: '#b91c1c',
  };
}

const OV = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)', display: 'flex',
  alignItems: 'center', justifyContent: 'center', zIndex: 10050, padding: 12 };

export default function LucchettoConsistenze({ lucchetto, codiceFiscale, ragioneSociale, lavorabile, dettaglio, screenshotUrl, onClose, dark = false }) {
  const [shot, setShot] = useState(false);
  const { categorie, aggiornateAl } = raggruppaConsistenze(dettaglio);
  const hex = LUCCHETTO_HEX[lucchetto] || '#94a3b8';
  const isTouch = typeof window !== 'undefined' && !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  const p = palette(dark);
  const BOX = { width: 380, maxWidth: '94vw', height: '70vh', maxHeight: 560, display: 'flex',
    flexDirection: 'column', background: p.cardBg, color: p.ink, borderRadius: 14,
    boxShadow: '0 18px 60px rgba(0,0,0,.4)', overflow: 'hidden' };
  const HEAD = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
    padding: '12px 14px', borderBottom: `1px solid ${p.headBorder}` };
  const SUB = { padding: '8px 14px', borderBottom: `1px solid ${p.subBorder}`, background: p.subBg };
  const BODY = { flex: 1, overflowY: 'auto', padding: '10px 14px' };
  const CHIP = { display: 'inline-block', fontSize: 11, fontWeight: 800, letterSpacing: '.04em',
    color: p.chipColor, background: p.chipBg, padding: '2px 9px', borderRadius: 6, marginBottom: 5 };
  const ROW = { display: 'flex', justifyContent: 'space-between', gap: 12, padding: '4px 0',
    borderBottom: `1px solid ${p.rowBorder}`, fontSize: 12.5 };
  const XBTN = { border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 16, color: p.muted, lineHeight: 1 };
  const SHOTBTN = { border: `1px solid ${p.shotBorder}`, background: p.shotBg, borderRadius: 7, cursor: 'pointer',
    fontSize: 11, fontWeight: 600, color: p.shotColor, padding: '3px 9px' };
  return (
    <div onClick={onClose} style={OV}>
      <div onClick={(e) => e.stopPropagation()} style={BOX}>
        <div style={HEAD}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
            <span style={{ width: 11, height: 11, borderRadius: '50%', background: hex, flex: '0 0 auto',
              border: lucchetto === 'NON TROVATO' ? '1px solid #94a3b8' : 'none' }} />
            <b style={{ fontSize: 14, color: p.ink }}>{lucchetto || '—'}</b>
            {lavorabile != null && (
              <span style={{ fontSize: 11, fontWeight: 700, color: lavorabile ? p.okColor : p.noColor }}>
                {lavorabile ? 'lavorabile' : 'non lavorabile'}
              </span>
            )}
          </span>
          <button onClick={onClose} style={XBTN} aria-label="Chiudi">✕</button>
        </div>
        <div style={SUB}>
          <div style={{ fontWeight: 700, fontSize: 13, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {ragioneSociale || codiceFiscale || 'Cliente'}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 3, flexWrap: 'wrap' }}>
            {codiceFiscale && <span style={{ fontSize: 11, color: p.muted }}>{codiceFiscale}</span>}
            {aggiornateAl && <span style={{ fontSize: 11, color: p.faint }}>agg. {aggiornateAl}</span>}
            {screenshotUrl && <button onClick={() => setShot(true)} style={SHOTBTN}>Schermata SSMATE</button>}
          </div>
        </div>
        <div style={BODY}>
          {categorie.length === 0 ? (
            <div style={{ color: p.faint, fontSize: 13, padding: '14px 4px' }}>
              Nessuna consistenza per questo stato.
            </div>
          ) : categorie.map((cat) => (
            <div key={cat.id} style={{ marginBottom: 12 }}>
              <div style={CHIP}>{cat.id}</div>
              {cat.voci.map((v) => (
                <div key={v.k} style={ROW}>
                  <span style={{ color: p.muted }}>{v.label}</span>
                  <span style={{ fontWeight: 700, textAlign: 'right', color: p.ink }}>{v.valore}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      {shot && screenshotUrl && (
        <div onClick={() => setShot(false)}
          style={{ position: 'fixed', inset: 0, background: '#000', zIndex: 10060,
            display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={screenshotUrl} alt="Schermata non disponibile"
            style={{ maxWidth: '100vw', maxHeight: '100vh', objectFit: 'contain', display: 'block' }} />
          <button onClick={(e) => { e.stopPropagation(); setShot(false); }} aria-label="Chiudi"
            style={{ position: 'absolute', top: 'calc(env(safe-area-inset-top, 0px) + 10px)', right: 14,
              width: 34, height: 34, borderRadius: 17, border: 'none', background: 'rgba(0,0,0,.55)',
              color: '#fff', fontSize: 17, cursor: 'pointer', lineHeight: 1 }}>✕</button>
          <div style={{ position: 'absolute', bottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)', left: 0, right: 0,
            textAlign: 'center', color: 'rgba(255,255,255,.65)', fontSize: 12, pointerEvents: 'none' }}>
            {isTouch ? 'Ruota il telefono per ingrandire · tocca per chiudere' : 'Tocca per chiudere'}
          </div>
        </div>
      )}
    </div>
  );
}
